import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { Country } from "../core/model/country";
import { CountryService } from "../core/service/country.service";

@Component({
  selector: "app-country",
  templateUrl: "./country.component.html",
  styleUrls: ["./country.component.scss"],
})
export class CountryComponent implements OnInit {
  countries: Country[];

  constructor(
    private _router: Router,
    private _countryService: CountryService
  ) {}

  ngOnInit() {
    this.getCountries();
  }

  getCountries() {
    this._countryService.getAllCountries().subscribe(
      (data) => {
        this.countries = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }
}
